import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import { DEFAULT_CONNECTION_ID } from '@redviking/argonaut-util/types/connections/connection-config';

export const mqttPublishNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('mqttPublish'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        retain: z.boolean(),
        connectionId: z.string().default(DEFAULT_CONNECTION_ID),
        qos: z.union([
            z.literal(0),
            z.literal(1),
            z.literal(2),
        ]),
    })),
}));
export type MqttPublishNodeCfgSchema = z.infer<typeof mqttPublishNodeCfgSchema>;

export const mqttPublishNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: () => {
            const ret: {
                topic: 'string';
                payload: 'varValue';
            } = {
                topic: 'string',
                payload: 'varValue',
            };
            return ret;
        },
        outputs: () => ({}),
    },
} satisfies NodeSocketCfg<MqttPublishNodeCfgSchema>;
